// KpiCard.jsx — small institutional metric card
import React from "react";
import { Box } from "@mui/material";

export default function KpiCard({ label, value, sub, accent = "#1E2A38", icon, testid }) {
  return (
    <Box data-testid={testid} sx={{
      background: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: 1, p: 2.4,
      position: "relative", overflow: "hidden",
      borderLeft: `3px solid ${accent}`,
      transition: "border-color 0.2s ease, transform 0.18s ease",
      "&:hover": { transform: "translateY(-1px)" },
    }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box className="cb-kpi-label">{label}</Box>
        {icon && <Box sx={{ color: accent, opacity: 0.7 }}>{icon}</Box>}
      </Box>
      <Box className="cb-kpi-value" sx={{ mt: 0.6 }}>{value}</Box>
      {sub && (
        <Box sx={{ fontSize: 11.5, color: "#6B7280", mt: 0.6, fontFamily: "IBM Plex Mono, monospace", letterSpacing: "0.04em" }}>
          {sub}
        </Box>
      )}
    </Box>
  );
}
